<ng-container *ngIf="sessionQuery.getUserObservable() | async as user; else publicLanding">
  <app-landing
    [user]="user"
  ></app-landing>
</ng-container>

<ng-template #publicLanding>
  <app-public-landing></app-public-landing>
</ng-template>
